"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDetails = exports.removeAuthToken = exports.setAuthToken = exports.getAuthToken = exports.UPLOAD_BASE_URL = exports.API_BASE_URL = void 0;
// Configuration constants
exports.API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
exports.UPLOAD_BASE_URL = process.env.REACT_APP_UPLOAD_BASE_URL;
// Helper function to get auth token from localStorage (pure React approach)
const getAuthToken = () => {
    var _a;
    const token = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith('crm-access-token='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    console.log(token);
    return token || null;
};
exports.getAuthToken = getAuthToken;
// Helper function to set auth token in localStorage
const setAuthToken = (token) => {
    localStorage.setItem('auth-token', token);
};
exports.setAuthToken = setAuthToken;
// Helper function to remove auth token from localStorage
const removeAuthToken = () => {
    localStorage.removeItem('auth-token');
};
exports.removeAuthToken = removeAuthToken;
// Helper function to get auth token from localStorage (pure React approach)
const getUserDetails = () => {
    var _a;
    const userDetails = (_a = document.cookie
        .split('; ')
        .find(row => row.startsWith('crm-user-detail='))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    console.log(userDetails);
    return userDetails ? JSON.parse(decodeURIComponent(userDetails)) : {};
};
exports.getUserDetails = getUserDetails;
